import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import BackgroundMusic from "../../components/BackgroundMusic";
import QuickSwapPopup from "../../components/QuickSwapPopup";
import SlotHeader from "../../components/SlotMachine/Header/SlotHeader";
import SlotMachineMain from "../../components/SlotMachine/Main/SlotMachineMain";

import bgMusic from "../../assets/sfxs/Slot/slot_bg.mp3";

import { useAppDispatch, useAppSelector } from "../../app/hooks";
import useGlobalSound from "../../hook/useGlobalSound";

import { getBusinessProfileAction } from "../../reducers/business.slice";
import {
  getSlotMachinesAction,
  setCurrentSlotMachineId,
  updateDefaultBetAmount,
} from "../../reducers/slot.slice";

import useStyles from "./index.styles";

const Slot = () => {
  const dispatch = useAppDispatch();
  const { classes } = useStyles();
  const { cityId } = useParams();
  const { muted } = useGlobalSound();

  const [openQuickSwap, setOpenQuickSwap] = useState(false);

  const { currentSlotMachineId, slotMachines } = useAppSelector(
    (state) => state.slot
  );

  useEffect(() => {
    dispatch(getSlotMachinesAction());
  }, [dispatch]);

  useEffect(() => {
    const slotId = Number(cityId);

    dispatch(setCurrentSlotMachineId(slotId));
  }, [dispatch, cityId]);

  useEffect(() => {
    dispatch(getBusinessProfileAction({ itemId: 47, cityId: Number(cityId) }));
  }, [dispatch, cityId]);

  useEffect(() => {
    if (!slotMachines[currentSlotMachineId]) return;

    dispatch(updateDefaultBetAmount(slotMachines[currentSlotMachineId].minBet));
  }, [currentSlotMachineId, dispatch, slotMachines]);

  return (
    <Box className={classes.body}>
      <BackgroundMusic muted={muted} backgroundMusic={bgMusic} volume={0.05} />
      <SlotHeader handleOpenQuickSwap={() => setOpenQuickSwap(true)} />

      <Box className={classes.slotMachineBody}>
        <SlotMachineMain />
      </Box>

      <QuickSwapPopup
        openPopup={openQuickSwap}
        handleClose={() => {
          setOpenQuickSwap(false);
        }}
      />
    </Box>
  );
};

export default Slot;
